import { createApi } from "@reduxjs/toolkit/query/react";
import { generateClient } from 'aws-amplify/api';
import { getUserDetailsQuery } from "./queries/getUserDetails/getUserDetailsQuery";
import { transform as getUserDetailsTransform } from "./queries/getUserDetails/transform";
import { transform as getAppSearchTransform } from "./queries/ApplicationSearch/transform";
import { getUserPoolDetailsQuery } from "./queries/getUserPoolDetails/getUserPoolDetailsQuery";
import { transform as getUserPoolTransform } from "./queries/getUserPoolDetails/transform";
import { getUserPoolNamesQuery } from "./queries/getUserPoolNames/getUserPoolNamesQuery";
import { getAppSearchDetails } from "./queries/ApplicationSearch/getAppSearchDetailsQuery";
import { getAppSearchNames } from "./queries/ApplicationSearch/getAppSearchNamesQuery";
import { getAppSearchRoles } from "./queries/ApplicationSearch/getAppSearchRolesQuery";
import { createUser, getCreateUserInput } from "./queries/mutations";
import { GqlErrorTransformer } from "../util/GqlErrorTransformer";
import { API_ENDPOINT_NAMES } from "../../util/constants";

const client = generateClient()

export const graphqlApi = createApi({
    reducerPath: "graphqlApi",
    endpoints: (builder) => ({
        getUserDetails: builder.query({
            queryFn: async (variables) => {
                return await GqlErrorTransformer(async () => {
                    const response = await client.graphql({
                        query: getUserDetailsQuery,
                        variables: variables,
                    });
                    return { data: getUserDetailsTransform(response.data) }
                });
            },
        }),
        getUserPoolNames: builder.query({
            queryFn: async () => {
                const response = await client.graphql({
                    query: getUserPoolNamesQuery,
                });
                return { data: response.data.getUserPoolNames }
            }
        }),
        getUserPoolDetails: builder.query({
            queryFn: async (variables) => {
                const response = await client.graphql({
                    query: getUserPoolDetailsQuery,
                    variables: variables,
                });
                return { data: getUserPoolTransform(response.data.getUserPoolDetails) };
            }
        }),
        appSearchNames: builder.query({
            queryFn: async (variables) => {
                const response = await client.graphql({
                    query: getAppSearchNames,
                    variables: variables,
                });
                console.log("Graphql response", response.data);
                return { data: response.data };
            }
        }),
        appSearchRoles: builder.query({
            queryFn: async (variables) => {
                    const response = await client.graphql({
                        query: getAppSearchRoles,
                        variables: variables,
                    });
                    console.log("Graphql response", response.data);
                    return { data: response.data };
            },
        }),
        appSearch: builder.query({
            queryFn: async (variables) => {
                    const response = await client.graphql({
                        query: getAppSearchDetails,
                        variables: variables,
                });
                console.log("Graphql getAppSearchData response", response);
                return { data: getAppSearchTransform(response.data) };
            }
        }),
        [API_ENDPOINT_NAMES.createUser]: builder.mutation({
            queryFn: async ([id, password]) => {
                return await GqlErrorTransformer(async () => {
                    return await client.graphql({
                        query: createUser,
                        variables: getCreateUserInput(id, password),
                    });
                });
            } 
        }),
    }),
});

export const { useGetUserDetailsQuery, useLazyGetUserDetailsQuery, useGetUserPoolNamesQuery, useLazyGetUserPoolNamesQuery, useGetUserPoolDetailsQuery, useLazyuseGetUserPoolDetailsQuery, useAppSearchQuery, useAppSearchNamesQuery, useAppSearchRolesQuery, useCreateUserMutation } = graphqlApi;